module.exports = __webpack_public_path__ + "static/media/st_anthonys_logo-removebg-preview-3.d952a2b2.png";